/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FunnelSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M192,120H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z" />
        <Path d="M232,72H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Z" />
        <Path d="M152,168H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" />
      </G>
    </Svg>
  );
}

export default FunnelSimple;
